<main class="main-container">
    <div class="row paragraph mt-3">
        <div class="col-12 heading-2">
            Step 1: Personal Information
        </div>
    </div>
    <form [formGroup]="estateAgentForm" (ngSubmit)="onSubmit()">
        <div class="row paragraph mt-4">
            <div class="bold">
                <span class="burnt-red">|</span>
                According to your Fidelity Fund Certificate, what is your status as an estate agent/commercial broker?
            </div>
        </div>
        <div class="row paragraph mt-2">
            <mat-radio-group formControlName="status">
                <div *ngFor="let status of estateAgentStatuses">
                    <mat-radio-button [value]="status" [disabled]="(isNotPrincipal && status.value === 'Principal/Director/Master Property Practitioner') ||
                   (isPrincipal && (status.value === 'Intern/Candidate Property Practitioner' 
                   || status.value === 'Full status/Professional Property Practitioner'))">
                        {{ status.value }}
                    </mat-radio-button>
                </div>
            </mat-radio-group>
            <div class="mt-2"><b>Please note:</b> Principals must register first. Practitioners on their team will then
                receive a link via
                email.</div>
        </div>
        <div class="row paragraph mt-4">
            <div class="col-12">
                <div class="bold">
                    <span class="burnt-red">|</span>
                    The metro you operate in most frequently:
                </div>
            </div>
        </div>
        <div class="row paragraph mt-2">
            <mat-radio-group formControlName="metro">
                <div *ngFor="let metro of metroList">
                    <mat-radio-button [value]="metro.id">
                        {{ metro.description }}
                    </mat-radio-button>
                </div>
            </mat-radio-group>
            <div *ngIf="estateAgentForm.get('metro').invalid && estateAgentForm.get('metro').touched"
                class="error-message">
                <small *ngIf="estateAgentForm.get('metro').value.invalid">
                    Please select a metro.
                </small>
            </div>
        </div>
        <div class=" row paragraph mt-4">
            <div formArrayName="sectors">
                <div class="bold">
                    <span class="burnt-red">|</span>
                    In which property sectors do you <u>specialise</u> (have extensive experience and
                    knowledge)?
                </div>
                <div *ngFor="let sector of propertySectors; let i = index" class="mt-1">
                    <mat-checkbox [formControlName]="i">
                        {{ sector.value === 'Other' && isOtherSectorChecked()
                        ? sector.value + ' - Please specify'
                        : sector.value }}
                    </mat-checkbox>
                </div>
            </div>
            <div *ngIf="isOtherSectorChecked()" class="mt-2">
                <input class="mat-input-section" id="otherSectors" maxlength="250" formControlName="otherSectors"
                    placeholder="Required if other is selected" type="text">
            </div>
        </div>
        <div class="row paragraph mt-4">
            <div class="col-12">
                <div class="bold">
                    How long have you been operating as a <u>registered</u> Estate Agent?
                </div>
            </div>
            <div class="col-12">
                <div class="row align-bottom">
                    <div class="col-auto years-label">
                        Years:
                    </div>
                    <div class="col-5">
                        <input class="mat-input-section placeholder-visible" id="yearsInOperation"
                            formControlName="yearsInOperation" required placeholder="12" type="number">
                        <div *ngIf="estateAgentForm.get('yearsInOperation').invalid && estateAgentForm.get('yearsInOperation').touched"
                            class="error-message">
                            <small *ngIf="estateAgentForm.get('yearsInOperation').errors?.min">
                                Years cannot be less than 0.
                            </small>
                            <small *ngIf="estateAgentForm.get('yearsInOperation').errors?.max">
                                Years cannot exceed 100.
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row paragraph mt-5">
            <div class="text-center">
                <button class="button" type="submit" [disabled]="estateAgentForm.invalid">SUBMIT</button>
            </div>
        </div>
    </form>
</main>